import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import { initializeRecaptchaConfig } from 'firebase/auth';
import { firebaseConfig } from '../firebaseConfig';

firebase.initializeApp(firebaseConfig);

// Identity Platform runs with the reCAPTCHA Enterprise integration enabled
// (email/password + SMS). Prefetching the config here lets the SDK attach
// assessment tokens from the first auth call; sign-in still works if it fails.
initializeRecaptchaConfig(firebase.auth()).catch(() => {});

export const db = firebase.firestore();
export default firebase;
